import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function TravelTime(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "TravelTime", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m7.02467 24.0204 12.09363.8613.8613 12.0936c.0561.5024.2778.9719.6302 1.3344.3523.3625.8152.5976 1.3158.668.5006.0705 1.0104-.0275 1.4492-.2787.4387-.2511.7814-.6411.9741-1.1085l10.4792-25.4447c.1714-.4158.2159-.8732.1278-1.3143-.0882-.4411-.3049-.84629-.623-1.16438-.3181-.31808-.7233-.53486-1.1644-.62298-.4411-.08813-.8984-.04366-1.3143.1278L6.40949 19.6511c-.46736.1927-.85735.5354-1.10851.9741-.25116.4388-.34921.9486-.27873 1.4492.07048.5006.3055.9635.66804 1.3158.36254.3524.83198.5741 1.33438.6302Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M34.5 34c4.6944 0 8.5-3.8056 8.5-8.5S39.1944 17 34.5 17 26 20.8056 26 25.5s3.8056 8.5 8.5 8.5Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M33.9048 27.3333c-.5429 0-.9048-.3619-.9048-.9047v-4.5238c0-.5429.3619-.9048.9048-.9048.5428 0 .9047.3619.9047.9048v4.5238c0 .5428-.3619.9047-.9047.9047Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M37.5238 27.333h-3.619c-.5429 0-.9048-.3619-.9048-.9048s.3619-.9048.9048-.9048h3.619c.5429 0 .9048.3619.9048.9048s-.3619.9048-.9048.9048Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
TravelTime.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "TravelTime"
};
validateTidalLicense();
export {
  TravelTime
};
//# sourceMappingURL=TravelTime.js.map
